// extracted by mini-css-extract-plugin
module.exports =  {"columns":"C9JRvEDKysX9UP2X5TOn","content":"MIX5w7b5XJBqrFj4SDMZ"};